import React from 'react';
import SVGIcon from "../../components/Utils/svgIcons";
class ListaItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.items || [],
            opened: false,
            title: props.title || "title"
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(event) {
        const object = {
            url: event.target.attributes.getNamedItem("url").value,
            visible: event.target.attributes.getNamedItem("visible").value === "true",
            layerName: event.target.attributes.getNamedItem("layer").value,
            type: event.target.attributes.getNamedItem("layertype").value,
            label: event.target.attributes.getNamedItem("label").value,
            link:event.target.attributes.getNamedItem("link").value,
            fuente:event.target.attributes.getNamedItem("fuente").value,
            id: event.target.id,
            checked: event.target.checked,
            init: false
        };
        this.props.onChange(object);
    }
    render() {
        let { title, opened, data } = this.state;
        if(title.split(".").length>0){
            title=title.split(".")[1];
        }
        if (data.length > 0) {
            return (
                <div
                    {...{
                        className: `accordion-item, ${opened && 'accordion-item--opened'}`
                    }}
                >
                    <div {...{ className: 'accordion-item__line', onClick: () => { this.setState({ opened: !opened }) } }}>
                        <h3 {...{ className: 'accordion-item__title' }}>
                            {title}
                        </h3>
                        <span {...{ className: 'accordion-item__icon' }} />
                    </div>
                    <div {...{ className: 'accordion-item__inner' }}>
                        <div {...{ className: 'accordion-item__content' }}>
                            {data.map((item, key) => {
                                return (
                                    <div key={key} className="custom-control custom-checkbox mt-1">
                                        <input onChange={this.handleChange} type="checkbox" className="custom-control-input"
                                            url={item.url}
                                            id={item.id}
                                            layer={item.layerName}
                                            layertype={item.type}
                                            visible={`${item.visible}`}
                                            label={item.label}
                                            fuente={item.fuente}
                                            defaultChecked={item.visible}
                                            link={item.link}
                                        />
                                        <label className="ml-2 custom-control-label" htmlFor={item.id}>{item.label}</label>
                                        <span className="info-icon pointer " title={"Fuente : "+item.fuente}>
                                            <SVGIcon id={'shape-info'}/>
                                        </span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )
        } else {
            return <div></div>;
        }
    }
}

export default ListaItem;